"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Terminal, Cpu, Database, Network } from "lucide-react";
const faqData = [{
  question: "How does GOTMEDS.IO verify my prescription with my doctor?",
  answer: "Our system integrates directly with Atlanta's top medical networks. Once you submit your request, our clinical team validates the prescription with your physician's office via a secure, HIPAA-compliant portal to ensure absolute accuracy before fulfillment.",
  linkText: "View Verification Process",
  linkUrl: "/CareCyclePage",
  icon: Database
}, {
  question: "What is the typical delivery window for prescriptions in Atlanta?",
  answer: "We prioritize speed and security. Most prescriptions are delivered within 2 to 4 hours of verification. Our local couriers are trained in medical handling and provide real-time tracking from the pharmacy to your doorstep.",
  linkText: "Track Your Delivery",
  linkUrl: "/PatientSupportPage",
  icon: Network
}, {
  question: "Is my medical information kept confidential during delivery?",
  answer: "Absolutely. We employ 'Clinical Luxury' standards, meaning all medications are transported in tamper-evident, discreet packaging. Our couriers only see the necessary delivery details, and your full medical history remains encrypted.",
  linkText: "Privacy & Compliance",
  linkUrl: "/PatientSupportPage",
  icon: Cpu
}, {
  question: "Can I use GOTMEDS.IO if my doctor isn't in your primary network?",
  answer: "Yes. While we have deep integrations with top Atlanta physicians, we can coordinate with any licensed medical professional. Simply provide your doctor's details, and our team will handle the coordination and pharmacy logistics.",
  linkText: "Partner with Us",
  linkUrl: "/MedicalPartnersPage",
  icon: Terminal
}];
export default function Faq() {
  return <section data-section-id="223794" id="common-questions" className="bg-background text-foreground relative min-h-screen py-32 px-6 md:px-12 lg:px-24 overflow-hidden flex flex-col justify-center">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-primary/40 to-transparent" />
        <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-primary/40 to-transparent" />
        <div className="absolute top-1/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/10 to-transparent" />
      </div>

      <div className="max-w-4xl mx-auto w-full relative z-10">
        <div className="mb-16 md:mb-24">
          <div className="inline-flex items-center gap-2 px-3 py-1 mb-6 rounded-lg border border-primary/20 bg-primary/5 backdrop-blur-sm">
            <Terminal className="size-4 text-primary" />
            <span className="text-xs font-mono text-primary uppercase tracking-widest">
              Patient Inquiry
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-tight mb-6">
            Common <span className="text-primary">Questions</span>
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default max-w-2xl leading-relaxed">
            Everything you need to know about our premium prescription delivery service and how we coordinate with your Atlanta healthcare providers.
          </p>
        </div>

        <div className="bg-card/50 backdrop-blur-xl border border-border/60 rounded-2xl p-6 md:p-10 shadow-xl shadow-primary/5">
          <Accordion type="single" collapsible className="w-full">
            {faqData.map((faq, i) => {
            const Icon = faq.icon;
            return <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/60 py-2">
                  <AccordionTrigger className="text-left text-lg md:text-xl font-default font-semibold hover:text-primary transition-colors group py-6">
                    <div className="flex items-center gap-4">
                      <div className="p-2 rounded-md bg-accent text-primary group-hover:text-primary-foreground group-hover:bg-primary transition-all duration-300">
                        <Icon className="size-5" />
                      </div>
                      <span>{faq.question}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground font-default leading-relaxed pb-8 pl-14 md:pl-16">
                    <p className="mb-6 text-lg">{faq.answer}</p>
                    <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-secondary-foreground hover:bg-secondary px-4 py-2 rounded-lg transition-all font-mono text-sm border border-primary/10 shadow-sm">
                      <Link to={faq.linkUrl}>
                        {faq.linkText} <span className="ml-2">→</span>
                      </Link>
                    </Button>
                  </AccordionContent>
                </AccordionItem>;
          })}
          </Accordion>
        </div>
      </div>
    </section>;
}